import { TextAttributeHelper } from './text-attribute-helper';

export class DynamicListAttributeHelper extends TextAttributeHelper {}
